import React from 'react';

export default function OmniWidgetSoldOut({ tmntData, brand }) {
  const soldOutMessage = `${tmntData?.pdpStoreAvailability?.value}: `;
  const soldOutBrandClass = brand === 'hol' ? 'hol' : 'anf';
  return (
    <div className="crs-omni-widget" data-testid="sold-out-omni">
      <div className={`omni-widget-sold-out ${soldOutBrandClass}`}>
        <p>
          {soldOutMessage}
          <span className="description">
            {tmntData?.addToBagSoldOut?.value}
          </span>
        </p>
      </div>
    </div>
  );
}
